import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import Grid from '@magalu/stereo-ui/atoms/Grid';
import styled from 'styled-components';
export var Container = styled(Grid)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var PixelContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: none;\n"])));